import React, { useState, useEffect } from 'react';
import Helper from 'src/helper/Helper';
import { profileStore } from 'src/hooks/profile';
import Constants from 'src/helper/Constants';
import { useUserStore } from 'src/hooks/admin/user';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const ProfileAddressPopup = (props) => {
    const { companyNamePattern, addressPattern, countryCodes, zipCodePattern } = Constants;
    const { SetStatus, data } = props;
    const [detailValidation, setDetailValidation] = useState({});
    const [stateList, setStateList] = useState([]);
    const [{ countryList }, { get_country_list, get_state_list }, {  }] = profileStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [{ }, { get_user_shipping_address_detail }, { update_user_shipping_address }] = useUserStore();

    const [invoiceDetail, setInvoiceDetail] = useState({ addressType: data.type });

    useEffect(() => {
        async function fetchHere() {
            await get_country_list();
        }
        if (countryList?.length <= 0) {
            fetchHere()
        }
    }, [])

    useEffect(() => {
        if (Object.keys(data.addressInfo).length > 0) {
            if (Helper.valueIsNotNull(data.addressInfo?.address?.countryCode) && countryCodes.includes(data.addressInfo.address.countryCode)) {
                async function fetchStateList() {
                    setStateList(await get_state_list(data.addressInfo.address.countryCode))
                }
                fetchStateList()
            }
            setInvoiceDetail({ ...data.addressInfo.address, id: data.addressInfo.id, companyName: data.addressInfo.companyName, addressType: data.type })
        }
    }, [data.addressInfo])

    const onValueChange = (field, value) => {
        if (detailValidation && Object.keys(detailValidation).length > 0) {
            delete detailValidation[field];
        }
        setInvoiceDetail({ ...invoiceDetail, [field]: value });
    };

    const onSaveUser = async () => {
        let isValid = onValidateData();
        if (isValid) {

            const res = await update_user_shipping_address(invoiceDetail)
            if (res?.payload?.Message) {
                system_alert_indicator({
                    name: "accessDenied",
                    message: data?.payload?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
            }
            if (res.isSuccessFull) {
                await get_user_shipping_address_detail(data.userId);
                system_alert_indicator({
                    name: "adminconsole",
                    message: '<b>Shipping address</b> has been updated successfully.',
                    type: "success"
                })
            }
            SetStatus(false)

        }
    };

    const onValidateData = () => {
        let validationModal = {};
        let isCountryCode = (Helper.valueIsNotNull(invoiceDetail.countryCode));
        if ((!Helper.valueIsNotNull(invoiceDetail.companyName)) || (!Helper.validateRegex(invoiceDetail.companyName, companyNamePattern)) || (invoiceDetail.companyName.length > 100)) {
            validationModal.companyName = "A valid company name is required.";
        }
        if ((!Helper.valueIsNotNull(invoiceDetail.postalCode)) || (!(Helper.validateRegex(invoiceDetail.postalCode, zipCodePattern))) || (invoiceDetail.postalCode.length > 40)) {
            validationModal.postalCode = "A valid zip code is required.";
        }
        if (isCountryCode && countryCodes.includes(invoiceDetail.countryCode) && !Helper.valueIsNotNull(invoiceDetail.stateCode)) {
            validationModal.stateCode = "A valid State/Province is required.";
        }
        if ((!Helper.valueIsNotNull(invoiceDetail.addressLineOne)) || (!Helper.validateRegex(invoiceDetail.addressLineOne, addressPattern))) {
            validationModal.addressLineOne = "A valid address is required.";
        }
        if ((Helper.valueIsNotNull(invoiceDetail.addressLineTwo)) && ((!Helper.validateRegex(invoiceDetail.addressLineTwo, addressPattern)))) {
            validationModal.addressLineTwo = "A valid address is required.";
        }
        if ((!Helper.valueIsNotNull(invoiceDetail.cityName)) || (!Helper.validateRegex(invoiceDetail.cityName, addressPattern))) {
            validationModal.cityName = "A valid city is required.";
        }
        if (!isCountryCode) {
            validationModal.countryCode = "A valid country is required.";
        }
        setDetailValidation(validationModal);
        return Object.keys(validationModal).length === 0;
    };

    const renderStateListOnCountryChange = async (value) => {
        setStateList(await get_state_list(value))
    }

    return (
        <div className="avnet-modal modal-730">
            <div className="avnet-modal-inner">
                <button type="button" className="close" data-dismiss="modal" onClick={() => { SetStatus(false) }}>×</button>
                <div className="modal-header justify-content-center">
                    <h1 className="pcn-modal-heading"> Edit Shipping Address</h1>
                </div>
                <div className="modal-body">
                    <form>
                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="companyName" className="d-block">Company Name*</label>
                                <input
                                    type="text"
                                    className={`form-control form-control-sm ${detailValidation.companyName ? "error" : ""}`}
                                    id="companyName"
                                    placeholder="Enter Company Name"
                                    name="companyName"
                                    value={invoiceDetail.companyName}
                                    onChange={({ target: { value } }) => onValueChange("companyName", value)}
                                    maxLength={35}
                                />
                                {detailValidation.companyName && <p className="error">{detailValidation.companyName}</p>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="addressLineOne" className="d-block">Address 1*</label>
                                <input
                                    type="text"
                                    className={`form-control form-control-sm ${detailValidation.addressLineOne ? "error" : ""}`}
                                    id="addressLineOne"
                                    placeholder="Enter Address"
                                    name="addressLineOne"
                                    maxLength={35}
                                    value={invoiceDetail.addressLineOne}
                                    onChange={({ target: { value } }) => onValueChange("addressLineOne", value)}
                                />
                                {detailValidation.addressLineOne && <p className="error">{detailValidation.addressLineOne}</p>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="addressLineTwo" className="d-block">Address 2</label>
                                <input
                                    type="text"
                                    className={`form-control form-control-sm ${detailValidation.addressLineTwo ? "error" : ""}`}
                                    id="addressLineTwo"
                                    placeholder="Default Shadow"
                                    name="addressLineTwo"
                                    maxLength={35}
                                    value={invoiceDetail.addressLineTwo}
                                    onChange={({ target: { value } }) => onValueChange("addressLineTwo", value)}
                                />
                                {detailValidation.addressLineTwo && <p className="error">{detailValidation.addressLineTwo}</p>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="cityName" className="d-block">City*</label>
                                <input
                                    type="text"
                                    className={`form-control form-control-sm ${detailValidation.cityName ? "error" : ""}`}
                                    id="cityName"
                                    placeholder="Enter City"
                                    name="cityName"
                                    value={invoiceDetail.cityName}
                                    onChange={({ target: { value } }) => onValueChange("cityName", value)}
                                />
                                {detailValidation.cityName && <p className="error">{detailValidation.cityName}</p>}
                            </div>
                        </div>

                        <div className="bs5 row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="stateCode" className="d-block">{stateList.length !== 0 ? 'State/Province*' : 'State/Province'}</label>
                                    {(stateList.length !== 0) ?
                                        <>
                                            <div className='selectbox'>
                                                <select
                                                    className={`form-control form-control-sm ${detailValidation.stateCode ? "error" : ""}`}
                                                    name="stateCode"
                                                    value={invoiceDetail.stateCode}
                                                    onChange={({ target: { value } }) => onValueChange("stateCode", value)}
                                                >
                                                    <option value="">-Select-</option>
                                                    {stateList.map((v, i) => (
                                                        <option key={v.stateId} value={v.stateCode}>{v.stateName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            {detailValidation.stateCode && <p className="error">{detailValidation.stateCode}</p>}
                                        </>
                                        :
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${""}`}
                                            id="stateCode"
                                            placeholder="-Select-"
                                            name="stateCode"
                                            value={invoiceDetail.stateCode}
                                            onChange={({ target: { value } }) => onValueChange("stateCode", value)}
                                        />
                                    }
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="postalCode" className="d-block">Zip/Postal Code*</label>
                                    <input
                                        type="text"
                                        className={`form-control form-control-sm ${detailValidation.postalCode ? "error" : ""}`}
                                        id="postalCode"
                                        placeholder="Enter Zip Code"
                                        name="postalCode"
                                        value={invoiceDetail.postalCode}
                                        onChange={({ target: { value } }) => onValueChange("postalCode", value)}
                                    />
                                    {detailValidation.postalCode && <p className="error">{detailValidation.postalCode}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="countryCode" className="d-block">Country*</label>
                                <div className='selectbox'>
                                    <select
                                        className={`form-control form-control-sm ${detailValidation.countryCode ? "error" : ""}`}
                                        name="countryCode"
                                        value={invoiceDetail.countryCode}
                                        onChange={
                                            ({ target: { value } }) => {
                                                onValueChange("countryCode", value);
                                                setStateList([]);
                                                setInvoiceDetail({ ...invoiceDetail, countryCode: value, stateCode: '' });
                                                if (countryCodes.includes(value)) {
                                                    renderStateListOnCountryChange(value)
                                                }
                                            }
                                        }
                                    >
                                        <option value="" >Enter Country</option>

                                        {countryList?.map((v, i) => (
                                            <option key={v.countryId} value={v.countryCode}>{v.countryName}</option>
                                        ))}
                                    </select>
                                </div>
                                {detailValidation.countryCode && <p className="error">{detailValidation.countryCode}</p>}
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                    <button type="button" className="bs5 btn btn-secondary minw140" onClick={() => { SetStatus(false) }}>Cancel</button>
                    <button type="button" className="bs5 btn btn-primary minw140" onClick={onSaveUser}>Update</button>
                </div>
            </div>
        </div>
    );
};

export default ProfileAddressPopup;
